import {
  Box,
  FormGroup,
  MessageBlock,
  NavList,
  Paragraph,
} from '@deckee/deck-hand';
import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { LIFE_THREATENING_SITUATION_MESSAGE } from '../../../../configurations/incident-report';
import { captureEvent } from '../../../../services/event-capture';
import getBoundingAreasByLocation from '../../../../services/geofencing';
import { selectCurrentLocation } from '../../../../services/store/modules/geo-service';
import {
  resetTags,
  selectAvailableTypes,
  selectSelectedTypeKey,
  setArea,
  setType,
} from '../../../../services/store/modules/incident-report';
import BasicDrawerLayout from '../../../layouts/BasicDrawerLayout/BasicDrawerLayout';
import { AvailableTypesList } from '../../../../services/store/modules/incident-report/models';

const SelectIncidentTypePage: FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { path } = useRouteMatch();

  const [showMarinePollution, setShowMarinePollution] = useState(false);

  const incidentReportTypes = useSelector(selectAvailableTypes);
  const selectedType = useSelector(selectSelectedTypeKey);
  const { latitude, longitude } = useSelector(selectCurrentLocation);

  const handleSelectMarinePollution = async () => {
    await captureEvent({
      type: 'incident: type selected',
      payload: {
        incidentType: 'marine-pollution',
      },
      sendToAmplitude: true,
    });

    history.push(`${path}/marine-pollution`);
  };

  const handleSelectType = async (type: AvailableTypesList) => {
    await captureEvent({
      type: 'incident: type selected',
      payload: {
        incidentType: type,
      },
      sendToAmplitude: true,
    });

    dispatch(setType(type));
    // Clear any previous tags when a new type is selected
    if (type !== selectedType) dispatch(resetTags());
    history.push(`${path}/location`);
  };

  useEffect(() => {
    const boundingAreas = getBoundingAreasByLocation({
      longitude,
      latitude,
    });

    // only show the marine pollution link if in WA
    if (boundingAreas.includes('WESTERNAUSTRALIA')) {
      dispatch(setArea('WESTERNAUSTRALIA'));
      setShowMarinePollution(true);
    } else if (boundingAreas.includes('TASMANIA')) {
      dispatch(setArea('TASMANIA'));
    } else {
      dispatch(setArea('OTHER'));
    }
  }, [dispatch, latitude, longitude]);

  return (
    <BasicDrawerLayout
      showMapOverlay
      heading="Report an incident"
      showMenuBar={false}
    >
      <Box p="3" display="flex" flexDirection="column" alignItems="center">
        <MessageBlock type="warning">
          {LIFE_THREATENING_SITUATION_MESSAGE}
        </MessageBlock>

        <FormGroup heading="What type of incident are you reporting?">
          <NavList>
            {showMarinePollution && (
              <NavList.Item chevron onClick={handleSelectMarinePollution}>
                <Paragraph pl={2}>Marine pollution</Paragraph>
              </NavList.Item>
            )}

            {Object.entries(incidentReportTypes).map(([key, value]) => (
              <NavList.Item
                chevron
                key={key}
                onClick={() => handleSelectType(key)}
              >
                <Paragraph pl={2}>{value.key}</Paragraph>
              </NavList.Item>
            ))}
          </NavList>
        </FormGroup>
      </Box>
    </BasicDrawerLayout>
  );
};

export default SelectIncidentTypePage;
